import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { imagens } from '../../Func_genericas/valores_estaticos';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[100dvh] w-full flex-col items-center justify-center bg-white px-6 py-12">
      <p className="text-center text-lg font-medium text-gray-800 md:text-xl">
        404 Página não encontrada
      </p>

      <div className="mt-10 flex flex-col items-center gap-8">
        <img
          src={imagens.logo_login}
          alt="Vulpes"
          className="w-32 opacity-90 md:w-40"
        />
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="text-sm font-medium text-[#C94F1E] underline underline-offset-4 transition-colors hover:text-[#b84720] bg-transparent border-none cursor-pointer"
        >
          Voltar
        </button>
      </div>
    </div>
  );
}
